import type { GetProduitsOrganisationQueryResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { produitsOrganisation } from '~/msw/mocks/produitOrganisation'

export function getProduitsOrganisationHandler() {
  return http.get<
    { officeOid: string },
    never,
    GetProduitsOrganisationQueryResponse
  >('http://localhost:3000/api/v1/produits-organisation/:officeOid', () => {
    return HttpResponse.json(produitsOrganisation)
  })
}
